import { useLayoutEffect, useMemo, useState } from 'react';
import { useLatest } from 'react-use';
export const useBorderBoxSizeCallback = (element, onChange) => {
    const onChangeRef = useLatest(onChange);
    const resizeObserver = useMemo(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const borderBoxSize = entry.borderBoxSize.at(0);
                if (borderBoxSize) {
                    onChangeRef.current(borderBoxSize);
                }
            }
        });
        return resizeObserver;
    }, [onChangeRef]);
    useLayoutEffect(() => {
        if (element instanceof HTMLElement) {
            const box = element.getBoundingClientRect();
            onChangeRef.current({ blockSize: box.height, inlineSize: box.width });
            resizeObserver.observe(element, { box: 'border-box' });
            return () => resizeObserver.unobserve(element);
        }
        if (element?.current) {
            const el = element.current;
            const box = el.getBoundingClientRect();
            onChangeRef.current({ blockSize: box.height, inlineSize: box.width });
            resizeObserver.observe(el, { box: 'border-box' });
            return () => resizeObserver.unobserve(el);
        }
    }, [element, onChangeRef, resizeObserver]);
};
export const useBorderBoxSize = (ref, onChange) => {
    const [size, setSize] = useState({
        blockSize: 0,
        inlineSize: 0,
    });
    useBorderBoxSizeCallback(ref, (size) => {
        setSize(size);
        onChange?.(size);
    });
    return size;
};
//# sourceMappingURL=use-size.js.map